import { Component, inject, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import { GuruEntity } from '../../../../model/guru-entity';
import { ModelService } from '../../../../services/model-service';
import { UserStateService, ConfigurationSection } from '../../../../services/user-state.service';
import { SelectionUtils } from '../../../selection-utils';
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-swt-com-accessories',
  imports: [MatIcon],
  templateUrl: './swt-com-accessories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './swt-com-accessories.component.css',
})
export class SwtComAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  adapterSelection!: GuruEntity;
  ballValveSelection!: GuruEntity;
  hoseKitsSelection!: GuruEntity;
  waterValveSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.adapterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAdapter');
    this.ballValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBallValveConn');
    this.hoseKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKit');
    this.waterValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterValve');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }
}
